// assets
import { IconUser } from '@tabler/icons';

// constant
const icons = {
    IconUser
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const Userpages = {
    id: 'User management',
    title: 'User management',
    caption: 'manage all user related servicies',
    type: 'group',
    children: [
        {
            id: 'user',
            title: 'User',
            type: 'item',
            url: '/user',
            icon: icons.IconUser
        },
        {
            id: 'statistics',
            title: 'Statistics',
            type: 'item',
            url: '/user-statistics',
            icon: icons.IconUser
        },
        {
            id: 'categories',
            title: 'Categories',
            type: 'item',
            url: '/categories',
            icon: icons.IconUser
        },
        {
            id: 'interest',
            title: 'Interest',
            type: 'item',
            url: '/interest',
            icon: icons.IconUser
        }
    ]
};

export default Userpages;
